/**
 * Karte „Verweigerte Bestellungen" auf /auswertungen/bestellungen (GF-Wunsch 27.10.2026).
 * Backend `node-app/src/services/auswertungen/verweigerungService.ts`.
 */
import { fetchData } from './apiUtils';

export interface VerweigerungWoche {
  von: string;
  bis: string;
  kw: number;
  laufend: boolean;
  bestellungen: number;
  anfos: number;
  verweigert: number;
  anteil_verweigert: number | null;
  verweigert_mit_vorbestellung: number;
  verweigert_ohne_vorbestellung: number;
}

export interface VerweigerungAntwort {
  wochen: VerweigerungWoche[];
  summe: Omit<VerweigerungWoche, 'kw' | 'laufend'>;
  datenstand: string | null;
  vorbestellung_tage: number;
}

export const fetchVerweigerteBestellungen = async (): Promise<VerweigerungAntwort> => {
  const res = await fetchData<VerweigerungAntwort>('/api/auswertungen/bestellungen/verweigert');
  if (!res.success || res.data === undefined) throw new Error(res.error || 'Laden fehlgeschlagen');
  return res.data;
};
